import { render, staticRenderFns } from "./user-chat-panel.vue?vue&type=template&id=a2df135a&scoped=true&"
import script from "./user-chat-panel.vue?vue&type=script&lang=js&"
export * from "./user-chat-panel.vue?vue&type=script&lang=js&"
import style0 from "./user-chat-panel.vue?vue&type=style&index=0&id=a2df135a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2df135a",
  null
  
)

export default component.exports